import { render } from "./LandroverATheParnasP_2025.vue?vue&type=template&id=d738b9ac"
const script = {}

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__